(() => {
  function initCardSwipers() {
    document
      .querySelectorAll('.card-image-swiper:not([data-swiper-init])')
      .forEach(swiper => {
        const track = swiper.querySelector('.card-image-swiper__track');
        const slides = swiper.querySelectorAll('.card-image-swiper__slide');
        const dots = swiper.querySelectorAll('.card-image-swiper__dot');
        const total = slides.length;

        if (!track || total <= 1) return;

        swiper.setAttribute('data-swiper-init', '1');

        let currentIndex = 0;
        let startX = 0;
        let startY = 0;
        let touching = false;
        let blockClickUntil = 0;

        function goTo(index) {
          currentIndex = (index + total) % total;
          track.style.transform = `translateX(-${currentIndex * 100}%)`;

          dots.forEach((dot, i) => {
            dot.classList.toggle('active', i === currentIndex);
          });

          // Prioritize the image being shown.
          const img = slides[currentIndex].querySelector('img');
          if (img) img.loading = 'eager';
        }

        swiper.addEventListener('touchstart', event => {
          if (event.touches.length !== 1) {
            touching = false;
            return;
          }

          startX = event.touches[0].clientX;
          startY = event.touches[0].clientY;
          touching = true;
        }, { passive: true });

        swiper.addEventListener('touchend', event => {
          if (!touching || !event.changedTouches.length) return;

          const diffX = startX - event.changedTouches[0].clientX;
          const diffY = startY - event.changedTouches[0].clientY;

          if (Math.abs(diffX) > 30 && Math.abs(diffX) > Math.abs(diffY)) {
            goTo(diffX > 0 ? currentIndex + 1 : currentIndex - 1);
            blockClickUntil = Date.now() + 500;
          }

          touching = false;
        }, { passive: true });

        swiper.addEventListener('touchcancel', () => {
          touching = false;
        }, { passive: true });

        // Stop a swipe from accidentally opening the product.
        swiper.addEventListener('click', event => {
          if (Date.now() < blockClickUntil) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, true);

        const imageLink = swiper.closest('a.card__media');
        const host = imageLink && imageLink.parentElement;

        if (host) {
          host.classList.add('card-swipe-host');

          function addArrow(direction, label, symbol) {
            const button = document.createElement('button');
            button.type = 'button';
            button.className =
              `card-swipe-arrow card-swipe-arrow--${direction}`;
            button.setAttribute('aria-label', label);
            button.textContent = symbol;

            button.addEventListener('click', event => {
              event.preventDefault();
              event.stopPropagation();

              goTo(direction === 'prev'
                ? currentIndex - 1
                : currentIndex + 1);
            });

            // Keep buttons outside the product link.
            host.appendChild(button);
          }

          addArrow('prev', '上一張商品圖片', '‹');
          addArrow('next', '下一張商品圖片', '›');
        }
      });
  }

  function start() {
    initCardSwipers();

    const observer = new MutationObserver(() => {
      initCardSwipers();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', initCardSwipers);
})();
